<template>
  <a-modal
      :visible="visible"
      :width="1000"
      @cancel="$emit('cancel')"
      title="文档类别过滤"
      destroyOnClose>
    <div class="s-div">
      <a-table class="cate-table" :columns="cateSummary" :dataSource="initData" :rowKey="(record) => record.id" :pagination="false" bordered size="middle">
        <template slot="cateRoot" slot-scope="record">{{ record.name }}</template>
        <template slot="cateList" slot-scope="record">
          <a-tag class="cate-tag" v-for="cate in record.extras.cateList" :key="cate.id" @click="onCheck(cate)">
            {{ cate.name }}
          </a-tag>
        </template>
      </a-table>
    </div>
    <template slot="footer">
      <a-button type="danger" @click="$emit('nlFilter')" ghost>未关联</a-button>
      <a-button type="primary" @click="$emit('noFilter')" ghost>不过滤</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'caseTypeFilter',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      initData: {},
      cateSummary: [
        {
          title: '目录名称',
          key: 'name',
          scopedSlots: { customRender: 'cateRoot' },
          width: '180px',
          className: 'cate-name'
        },
        {
          title: '类别列表',
          key: 'cate',
          scopedSlots: { customRender: 'cateList' }
        }
      ]
    }
  },
  methods: {
    onCheck (data) {
      this.$emit('success', data.id, data.name)
    },
    init () {
      const that = this
      this.$http.get('/api/1/workflow/cate/get_doc_root_summary.json').then(function (response) {
        if (response.code !== 200) {
          return
        }
        that.initData = response.result
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cate-table /deep/ th {
  padding: 8px !important;
}

.cate-table /deep/ td {
  background: transparent !important;
  padding: 4px 6px !important;
}

.cate-tag {
  font-size: 14px;
  line-height: 22px;
  height: 24px;
  margin: 6px 6px;
  cursor: pointer;
}

.cate-table /deep/ td.cate-name {
}
</style>
